import { Stack } from '@mui/material';
import { useMemo } from 'react';

import { CopyText, ExpandableContent } from 'components';
import { useUserContextUtils } from 'hooks';
import { TradeMethod } from 'types';

type Props = {
  tradeMethods: ({ id: string } & Partial<TradeMethod>)[];
  maxVisible?: number;
};

const DEFAULT_MAX_VISIBLE = 3;

export const ExpandableTradeMethods: React.FC<Props> = ({
  tradeMethods = [],
  maxVisible = DEFAULT_MAX_VISIBLE,
}) => {
  const showToggleButton = useMemo(
    () => tradeMethods.length > maxVisible,
    [maxVisible, tradeMethods.length],
  );

  const { getTradeMethodLabel } = useUserContextUtils();

  return (
    <ExpandableContent showToggleButton={showToggleButton}>
      {(isExpanded) => {
        const displayMethods = isExpanded
          ? tradeMethods
          : tradeMethods.slice(0, maxVisible);

        return (
          <Stack direction="column" spacing={2}>
            {displayMethods.map((method) => (
              <Stack key={method.id} direction="column" spacing={0}>
                <CopyText text={method.id} />
                <div>{getTradeMethodLabel(method.id)}</div>
              </Stack>
            ))}
          </Stack>
        );
      }}
    </ExpandableContent>
  );
};
